import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { RepairsSummary } from '@app/interfaces/repairs-summary';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RepairSummaryService {

    constructor(private http: HttpClient, private configService: ConfigurationService) { }

    getRepairs(userId: string, tenancyReference: string): Observable<any> {
        const repairsApiUrl = this.configService.getConfig()?.shell.api.repairsApiUrl;
        //const repairsApiUrl = 'https://connect.api.local/repairs/'//this.configService.getConfig()?.shell.api.repairsApiUrl;
        return this.http.get<any>(repairsApiUrl + 'repairs?userId=' + userId + '&tenancyReference=' + tenancyReference)
    }

    deleteRepair(userId: string, tenancyReference: string, sorCode: string): Observable<any> {
        const repairsApiUrl = this.configService.getConfig()?.shell.api.repairsApiUrl;
        //const repairsApiUrl = 'https://connect.api.local/repairs/'//this.configService.getConfig()?.shell.api.repairsApiUrl;
        return this.http.delete<any>(repairsApiUrl + 'repairs?userId=' + userId + '&tenancyReference=' + tenancyReference + '&sorCode=' + sorCode)
    }
}
